import { render, staticRenderFns } from "./Witness.vue?vue&type=template&id=ac80ad08&"
import script from "./Witness.vue?vue&type=script&lang=js&"
export * from "./Witness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports